import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillAiFlowStore } from '../state/bill-ai-flow.store';
import { BillAiFlowStep } from '../state/bill-ai-flow.models';

@Component({
  selector: 'app-bill-ai-flow-step-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bill-ai-flow-step-header.component.html',
  styleUrl: './bill-ai-flow-step-header.component.scss'
})
export class BillAiFlowStepHeaderComponent {
  private state = inject(BillAiFlowStore);

  steps = this.state.steps;

  // Pre-computed step states (avoids method calls in template)
  stepStates = computed(() => {
    const current = this.state.currentStep();
    const completed = this.state.completedSteps();
    const fastTracked = this.state.fastTrackSkippedSteps();
    const result: Record<string, { active: boolean; completed: boolean; pending: boolean; fastTracked: boolean }> = {};
    for (const step of this.steps()) {
      const isActive = current === step.key;
      const isCompleted = completed.includes(step.key);
      const isFastTracked = fastTracked.includes(step.key);
      result[step.key] = { active: isActive, completed: isCompleted, pending: !isActive && !isCompleted, fastTracked: isFastTracked };
    }
    return result;
  });

  onStepClick(stepKey: BillAiFlowStep): void {
    if (this.stepStates()[stepKey]?.completed) {
      this.state.goToStep(stepKey);
    }
  }
}
